import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	empty: {
		id: 'issue-field-issue-type-editview-full.issue-type.empty',
		defaultMessage: 'No matches found',
		description: 'Message when no options are found in a select',
	},
	failedFetch: {
		id: 'issue-field-issue-type-editview-full.issue-type.failed-fetch',
		defaultMessage: 'Search failed.',
		description: 'Message when fetching suggestions fails',
	},
	loading: {
		id: 'issue-field-issue-type-editview-full.issue-type.loading',
		defaultMessage: 'Searching...',
		description: 'Message when options are being loaded from the server.',
	},
	placeholder: {
		id: 'issue-field-issue-type-editview-full.issue-type.placeholder',
		defaultMessage: 'Select Issue Type',
		description: 'Placeholder message when no option is selected',
	},
	label: {
		id: 'issue-field-issue-type-editview-full.issue-type.label',
		defaultMessage: 'Issue Type',
		description: 'Aria label for accessibility',
	},
});
